import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import './App.css';

import Navbar from './components/Navbar';
import About from './components/About';
import Textform from './components/TextForm';
import Alert from './components/Alert';

function Textutils() {
    const [mode, setMode] = useState('light'); // Whether dark mode is enabled or not
    const [alert, setAlert] = useState(null);

    const showAlert = (message, type) => {
        setAlert({
            msg: message,
            type: type
        })
        setTimeout(() => {
            setAlert(null);
        }, 1500);
    }

    const toggleMode = () => {
        if (mode === 'light') {
            setMode('dark');
            document.body.style.backgroundColor = '#0f0f0f';
            showAlert("Dark mode has been enabled", "success");
        }
        else {
            setMode('light');
            document.body.style.backgroundColor = 'white';
            showAlert("Light mode has been enabled", "success");
        }
    }
    return (
        <>
            <BrowserRouter>
                <Navbar title="TextUtils" mode={mode} toggleMode={toggleMode} key={new Date()} />
                <Alert alert={alert} />
                <div>
                    <Routes>
                        <Route path='/' element={<Textform showAlert={showAlert} heading="TextCraft - Streamlined Text Editor Powered by React" mode={mode} />} />
                        <Route path='/About' element={<About mode={mode} />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </>
    );
}

export default Textutils;
